// Generated by BUCKLESCRIPT VERSION 5.0.4, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");
var React = require("react");
var Gatsby = require("gatsby");

var header = Css.style(/* :: */[
      Css.backgroundColor(Css.hex("db4d3f")),
      /* :: */[
        Css.marginBottom(Css.px(16)),
        /* [] */0
      ]
    ]);

var h1 = Css.style(/* :: */[
      Css.margin(Css.px(0)),
      /* [] */0
    ]);

var link = Css.style(/* :: */[
      Css.color(Css.white),
      /* :: */[
        Css.textDecoration(Css.none),
        /* :: */[
          Css.marginRight(Css.px(16)),
          /* [] */0
        ]
      ]
    ]);

var nav = Css.style(/* :: */[
      Css.display(/* flex */-1010954439),
      /* :: */[
        Css.alignItems(/* center */98248149),
        /* :: */[
          Css.justifyContent(/* spaceBetween */516682146),
          /* :: */[
            Css.margin2(Css.px(0), /* auto */-1065951377),
            /* :: */[
              Css.maxWidth(Css.px(1000)),
              /* :: */[
                Css.padding2(Css.px(0), Css.px(24)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var logo = Css.style(/* :: */[
      Css.height(Css.px(64)),
      /* :: */[
        Css.marginRight(Css.px(36)),
        /* :: */[
          Css.marginTop(Css.px(8)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* header */header,
  /* h1 */h1,
  /* link */link,
  /* nav */nav,
  /* logo */logo
];

function Header(Props) {
  Props._siteTitle;
  return React.createElement("header", {
              className: header
            }, React.createElement("nav", {
                  className: nav
                }, React.createElement(Gatsby.Link, {
                      to: "/",
                      className: link,
                      children: React.createElement("img", {
                            className: logo,
                            alt: "logo",
                            src: "/images/iw-logo-1.png"
                          })
                    }), React.createElement("div", undefined, React.createElement(Gatsby.Link, {
                          to: "/blog",
                          className: link,
                          children: "Blog"
                        }), React.createElement(Gatsby.Link, {
                          to: "/where",
                          className: link,
                          children: "Where"
                        }), React.createElement(Gatsby.Link, {
                          to: "/",
                          className: link,
                          children: "About"
                        }))));
}

var make = Header;

var $$default = Header;

exports.Styles = Styles;
exports.make = make;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
/* header Not a pure module */
